module.exports = __webpack_public_path__ + "img/159.911086e2.png";